import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'

import {
  ISiteBoxDocument,
  SiteBoxDocument,
} from '@core/entities/SiteBoxDocument'

const dataTransformer = (response: ISiteBoxDocument) =>
  SiteBoxDocument.new(response)

export const useGetSiteBoxDocument = (
  payload: RequestTypes['getDocument'],
  options?: UseQueryOptions<
    ISiteBoxDocument,
    RequestErrorType,
    SiteBoxDocument
  >,
) => {
  return useQuery({
    ...siteBoxDocumentsKeys.byId(payload),
    enabled: !!payload.documentId,
    select: dataTransformer,
    ...options,
  })
}
